<form [formGroup]="form">
  <div class="add-address-dialog">

    <p class="add-address-header">ADD ADDRESS</p>

    <!--
      Says where it goes. An address added here appears against the customer everywhere,
      including the ship-to list on an order, which is correct when it is a real address
      for them but is not obvious from a dialog headed only "Add Address".
    -->
    <p class="add-address-subtext">
      Added to this customer, so it is available on their orders too. You still have to
      save the submission for it to be used.
    </p>

    <!-- Two columns, reading down the left then down the right, as the alternative
         address dialog in Order Manager does. -->
    <div class="add-address-inputs-container">

      <div class="add-address-inputs-container-left">
        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="addressLine1" maxlength="100" cdkFocusInitial>
          </mat-form-field>
        </div>

        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Address Line 3</mat-label>
            <input matInput formControlName="addressLine3" maxlength="100">
          </mat-form-field>
        </div>

        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Province</mat-label>
            <input matInput formControlName="province" maxlength="100">
          </mat-form-field>
        </div>
      </div>

      <div class="add-address-inputs-container-right">
        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="addressLine2" maxlength="100">
          </mat-form-field>
        </div>

        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Town</mat-label>
            <input matInput formControlName="town" maxlength="100">
          </mat-form-field>
        </div>

        <div class="add-address-inputs">
          <mat-form-field class="add-address-input-space" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="postalCode" maxlength="10">
          </mat-form-field>
        </div>
      </div>

    </div>

    <div class="add-address-action-btn-container">
      <button class="cancel-address-btn" mat-flat-button type="button" (click)="cancel()">
        <p class="cancel-address-btn-text">CANCEL</p>
      </button>

      <!-- Disabled only when every box is empty. Nothing else is required: a half filled
           address is a worse address, not an invalid one, and a required field only
           pushes somebody into typing something false to get past it. -->
      <button class="add-address-btn" mat-flat-button color="primary" type="button"
              [disabled]="!hasAnything" (click)="add()">
        <p class="add-address-btn-text">ADD</p>
      </button>
    </div>

  </div>
</form>
